import { render, staticRenderFns } from "./InputBtn.vue?vue&type=template&id=17bf428f&"
import script from "./InputBtn.vue?vue&type=script&lang=js&"
export * from "./InputBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports